import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../environments/environment';
import * as firebase from 'firebase';

@Component({
  selector: 'contract-input',
  templateUrl: './contract-input.component.html',
  styleUrls: ['./contract-input.component.css']
})
export class ContractInputComponent implements OnInit {

  @Input()
  part: any;

  @Input()
  disabled: boolean = false;

  isTouched = false;

  constructor(private router: Router) { 
   
  }

 
  

  ngOnInit() {
    if (environment.production && !firebase.auth().currentUser) {
      this.router.navigate(['/']);
    };
    //this.part.content.split('\r\n').join('<br>');
  }

  isInvalid = () => {
    return this.part.required === true && (this.isTouched || this.part.submitted) && (!this.part.value || this.part.value === "");
  }

  isInvalidOib = () => {
    const isnum = /^\d+$/.test(this.part.value);
    return this.part.required === true && (this.isTouched || this.part.submitted) && (!this.part.value || this.part.value === "" || this.part.value.length !== 11 || !isnum);
  }

  onTouched = event => {
    this.isTouched = true;
  }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contract-input/contract-input.component.ts